export interface SearchBarSettings {
  showActions?: boolean;
  showActionsInMobile?: boolean;
  showButton?: boolean;
  buttonLabel?: string;
  buttonIcon?: string;
  buttonClass?: string;
  showButtonSecond?: boolean;
  buttonLabelSecond?: string;
  buttonIconSecond?: string;
  buttonClassSecond?: string;
  /** Рендерить вторую кнопку сразу после uploader (иначе — после основной). */
  buttonSecondAfterUploader?: boolean;
  showButtonThird?: boolean;
  buttonLabelThird?: string;
  buttonIconThird?: string;
  buttonClassThird?: string;
  showImportButton?: boolean;
  importButtonIcon?: string;
  importButtonTooltip?: string;
  /** Короткая подпись в углу icon-only кнопки импорта (например «Атриум»). */
  importButtonBadge?: string;
  /** Loading locker for import button */
  importButtonLoading?: boolean;
  showExportButton?: boolean;
  exportButtonIcon?: string;
  exportButtonTooltip?: string;
  /** Короткая подпись в углу icon-only кнопки экспорта (например «1С»). */
  exportButtonBadge?: string;
  /** Loading locker for export button */
  exportButtonLoading?: boolean;
  /** Кнопка «Печать / PDF» в полосе действий (после основных кнопок, через разделитель) */
  showPrintPdfButton?: boolean;
  printPdfButtonLabel?: string;
  showUploader?: boolean;
  uploaderButtonLabel?: string;
  uploaderClass?: string;
  showCountInfo?: boolean;
  showShareIcon?: boolean;
  showSearchInput?: boolean;
  /** Кнопка «Найти» слева от поля поиска (только фокус). По умолчанию в проекте выключено. */
  showFindFocusButton?: boolean;
  settingsShow?: boolean;
  settingsIcon?: string;
  tooltipDescription?: string;
  /** Показать `crm-saved-filter-dialog` в action-bar (контекст — `ListSearchService.savedFilterBarContext`). */
  showSavedFilterButton?: boolean;
  /** Класс кнопки «Шаблоны» в action-bar (v2: outlined, как «Печать / PDF»). */
  savedFilterButtonClass?: string;
  /** Светлая строка с заголовком страницы. На карточках v2 выключаем — номер живёт в `crm-card-header-v2`. */
  showPageTitleRow?: boolean;
}

/**
 * v2-дефолты для полосы списка: при `actionsSettings.next` без части полей
 * **не** наследуем их от предыдущего модуля — объединяем: `{ ...DEFAULT_SEARCH_BAR_SETTINGS, ...partial }`.
 */
export const DEFAULT_SEARCH_BAR_SETTINGS: Readonly<Required<SearchBarSettings>> = {
  showActions: true,
  showActionsInMobile: false,
  showButton: true,
  buttonLabel: 'Добавить',
  buttonIcon: 'pi pi-plus',
  buttonClass: 'p-button-primary white-space-nowrap',
  showButtonSecond: false,
  buttonLabelSecond: 'Добавить',
  buttonIconSecond: 'pi pi-plus',
  buttonClassSecond: 'p-button-outlined p-button-primary white-space-nowrap',
  buttonSecondAfterUploader: false,
  showButtonThird: false,
  buttonLabelThird: '',
  buttonIconThird: 'pi pi-search',
  buttonClassThird: 'p-button-info p-button-text',
  showImportButton: false,
  importButtonIcon: 'pi pi-download',
  importButtonTooltip: 'Импорт',
  importButtonBadge: '',
  importButtonLoading: false,
  showExportButton: false,
  exportButtonIcon: 'pi pi-upload',
  exportButtonTooltip: 'Экспорт',
  exportButtonBadge: '',
  exportButtonLoading: false,
  showPrintPdfButton: false,
  printPdfButtonLabel: 'Печать / PDF',
  showUploader: false,
  uploaderButtonLabel: 'Загрузить',
  uploaderClass: 'file-uploader-success',
  showCountInfo: true,
  showShareIcon: false,
  showSearchInput: true,
  showFindFocusButton: false,
  settingsShow: false,
  settingsIcon: 'pi pi-cog',
  tooltipDescription: undefined,
  showSavedFilterButton: false,
  savedFilterButtonClass: 'p-button-outlined white-space-nowrap',
  showPageTitleRow: true
};

/** Частичные настройки экрана поверх сбрасываемой базы (без залипания `buttonClass` с другого модуля). */
export function mergeSearchBarSettings(partial: SearchBarSettings): Readonly<Required<SearchBarSettings>> {
  const noUndefined = Object.fromEntries(
    (Object.entries(partial) as [keyof SearchBarSettings, SearchBarSettings[keyof SearchBarSettings]][]).filter(
      ([, v]) => v !== undefined
    )
  ) as SearchBarSettings;
  return { ...DEFAULT_SEARCH_BAR_SETTINGS, ...noUndefined };
}
